/**
 * The single place that decides which implementation of each device capability
 * the app uses. Feature code imports `native` and never learns whether it is
 * running in a browser tab or inside Capacitor (hard rule 7).
 *
 * Swapping to Capacitor is a change to this file: detect the platform and
 * return the plugin-backed objects instead of the web ones.
 */
import { webBiometrics, type BiometricsApi } from './biometrics'
import { webCamera, type CameraApi } from './camera'
import { webClipboard, type ClipboardApi } from './clipboard'
import { createDeviceApi, type DeviceApi } from './device'
import { webPush, type PushApi } from './push'
import { webSecureStorage, type SecureStorage } from './secure-storage'
import { webShare, type ShareApi } from './share'

export interface Native {
  storage: SecureStorage
  device: DeviceApi
  biometrics: BiometricsApi
  camera: CameraApi
  push: PushApi
  clipboard: ClipboardApi
  share: ShareApi
}

const storage = webSecureStorage

export const native: Native = {
  storage,
  device: createDeviceApi(storage),
  biometrics: webBiometrics,
  camera: webCamera,
  push: webPush,
  clipboard: webClipboard,
  share: webShare,
}

export type { BiometricsApi, CameraApi, ClipboardApi, DeviceApi, PushApi, SecureStorage, ShareApi }
